var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{key:_vm.userModel,staticClass:"page page-user"},[(_vm.userModel.uniqueKey)?_c('SceneUserProfile',{attrs:{"favoriteCollection":_vm.favoriteCollection,"userModel":_vm.userModel,"venueCheckinCollection":_vm.venueCheckinCollection}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }